export class Contact{
  id:number;
  name:string;
  email:string;
  phone:string;
  dateCreated:any;
  subject:string;
  message:string;
  checkData():boolean{
    if(this.name==null || this.email==null || this.subject==null || this.message==null || this.name=="" || this.email=="" || this.subject=="" || this.message=="")
      return false;
    return true;
  }
}
